import CandidateListRow from "./CreateCandidateListRow";
import Card from "react-bootstrap/Card";

const CreateCandidatesList = ({ candidatesList, setSelectedCandidate }) => {
  return candidatesList.map((candidate, i) => (
    <Card key={i} className="default-card mb-3" style={{ height: "155px" }}>
      <CandidateListRow candidate={candidate} setSelectedCandidate={setSelectedCandidate} />
    </Card>
  ));
};

export default CreateCandidatesList;
